exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".you-may-also-like-carousel__nav-arrow[data-v-67f7c4e4]{color:#4c7499;font-size:32px;cursor:pointer}.you-may-also-like-carousel__nav-arrow--disabled[data-v-67f7c4e4]{color:#efefef}.you-may-also-like-carousel__nav-arrow-wrap[data-v-67f7c4e4]{text-align:center;margin-top:180px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67f7c4e4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//node_modules//bootstrap-sass//assets//stylesheets//bootstrap//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_variables.scss","D://BuildAgent3//work//1b321ff2a52467e6//Commerce//Commerce.Web//WebResources//vue//shared//scss//_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WebResources/vue/shared/components/catalog/YouMayAlsoLike/PackageCarousel.vue
// module id = 866
// module chunks = 0 2